/* tslint:disable */
/* eslint-disable */
/**
 * Marketplace Api
 * Marketplace Api description
 *
 * The version of the OpenAPI document: 1.0
 * Contact: develop@taykus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AvailabilityRequest } from '../models';
// @ts-ignore
import { Booking } from '../models';
// @ts-ignore
import { BookingPricesRequest } from '../models';
// @ts-ignore
import { BookingRequest } from '../models';
// @ts-ignore
import { BookingResult } from '../models';
// @ts-ignore
import { Player } from '../models';
// @ts-ignore
import { PlayersPricesResponse } from '../models';
// @ts-ignore
import { PreBooking } from '../models';
// @ts-ignore
import { PricesRequest } from '../models';
// @ts-ignore
import { TenantAvailabilityDTO } from '../models';
// @ts-ignore
import { TenantAvailabilityRequest } from '../models';
/**
 * BookingApi - axios parameter creator
 * @export
 */
export const BookingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a result to the booking
         * @param {string} id The booking id
         * @param {BookingResult} bookingResult 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBookingResult: async (id: string, bookingResult: BookingResult, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addBookingResult', 'id', id)
            // verify required parameter 'bookingResult' is not null or undefined
            assertParamExists('addBookingResult', 'bookingResult', bookingResult)
            const localVarPath = `/api/booking/{id}/result`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookingResult, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a player
         * @param {string} id The booking id
         * @param {number} playerId The player id
         * @param {Player} player 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPlayer: async (id: string, playerId: number, player: Player, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addPlayer', 'id', id)
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('addPlayer', 'playerId', playerId)
            // verify required parameter 'player' is not null or undefined
            assertParamExists('addPlayer', 'player', player)
            const localVarPath = `/api/booking/{id}/player/{playerId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(player, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get bookings availability
         * @param {AvailabilityRequest} availabilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        availability: async (availabilityRequest: AvailabilityRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'availabilityRequest' is not null or undefined
            assertParamExists('availability', 'availabilityRequest', availabilityRequest)
            const localVarPath = `/api/booking/availability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(availabilityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel Booking
         * @param {string} id booking id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelBooking: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cancelBooking', 'id', id)
            const localVarPath = `/api/booking/cancel/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a sale to pay players
         * @param {string} id The booking id
         * @param {Array<number>} playerIds The player id list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSale: async (id: string, playerIds: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createSale', 'id', id)
            // verify required parameter 'playerIds' is not null or undefined
            assertParamExists('createSale', 'playerIds', playerIds)
            const localVarPath = `/api/booking/{id}/sale`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (playerIds) {
                localVarQueryParameter['playerIds'] = playerIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a player
         * @param {string} id The booking id
         * @param {number} playerId The player id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlayer: async (id: string, playerId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePlayer', 'id', id)
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('deletePlayer', 'playerId', playerId)
            const localVarPath = `/api/booking/{id}/player/{playerId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all customer\'s bookings
         * @param {number} start Zero-based page index
         * @param {number} size The page size
         * @param {boolean} [owner] True if bookings where owner is customer should be found. False if owner is customer or participant
         * @param {string} [include] Parameter to filter by date: all / next / old
         * @param {boolean} [includeCancelled] True to include cancelled bookings. False otherwise. Defaults to true
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findBookingByCustomer: async (start: number, size: number, owner?: boolean, include?: string, includeCancelled?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'start' is not null or undefined
            assertParamExists('findBookingByCustomer', 'start', start)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('findBookingByCustomer', 'size', size)
            const localVarPath = `/api/booking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (owner !== undefined) {
                localVarQueryParameter['owner'] = owner;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }

            if (includeCancelled !== undefined) {
                localVarQueryParameter['includeCancelled'] = includeCancelled;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a booking by id
         * @param {string} id The booking id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findBookingById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findBookingById', 'id', id)
            const localVarPath = `/api/booking/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a booking by crmId and tenantId
         * @param {string} tenantId The tenant id
         * @param {number} id The crm id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByCrmIdAndTenant: async (tenantId: string, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('findByCrmIdAndTenant', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findByCrmIdAndTenant', 'id', id)
            const localVarPath = `/api/booking/{tenantId}/{id}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get prices of players
         * @param {string} id The booking id
         * @param {Array<number>} playerIds The player id list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayersPrices: async (id: string, playerIds: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPlayersPrices', 'id', id)
            // verify required parameter 'playerIds' is not null or undefined
            assertParamExists('getPlayersPrices', 'playerIds', playerIds)
            const localVarPath = `/api/booking/{id}/players`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (playerIds) {
                localVarQueryParameter['playerIds'] = playerIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get prices about the participants of a future booking
         * @param {PricesRequest} pricesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrices: async (pricesRequest: PricesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pricesRequest' is not null or undefined
            assertParamExists('getPrices', 'pricesRequest', pricesRequest)
            const localVarPath = `/api/booking/price`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pricesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Move a player
         * @param {string} id The booking id
         * @param {number} playerId The player id
         * @param {number} targetPlayerId The page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        movePlayer: async (id: string, playerId: number, targetPlayerId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('movePlayer', 'id', id)
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('movePlayer', 'playerId', playerId)
            // verify required parameter 'targetPlayerId' is not null or undefined
            assertParamExists('movePlayer', 'targetPlayerId', targetPlayerId)
            const localVarPath = `/api/booking/{id}/player/{playerId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (targetPlayerId !== undefined) {
                localVarQueryParameter['targetPlayerId'] = targetPlayerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a booking
         * @param {BookingRequest} bookingRequest 
         * @param {string} [xTenant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prebooking: async (bookingRequest: BookingRequest, xTenant?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingRequest' is not null or undefined
            assertParamExists('prebooking', 'bookingRequest', bookingRequest)
            const localVarPath = `/api/booking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xTenant !== undefined && xTenant !== null) {
                localVarHeaderParameter['x-tenant'] = String(xTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get availability and prices about a Tenant
         * @param {TenantAvailabilityRequest} tenantAvailabilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantAvailability: async (tenantAvailabilityRequest: TenantAvailabilityRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantAvailabilityRequest' is not null or undefined
            assertParamExists('tenantAvailability', 'tenantAvailabilityRequest', tenantAvailabilityRequest)
            const localVarPath = `/api/booking/availability/price`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantAvailabilityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BookingApi - functional programming interface
 * @export
 */
export const BookingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BookingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add a result to the booking
         * @param {string} id The booking id
         * @param {BookingResult} bookingResult 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addBookingResult(id: string, bookingResult: BookingResult, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Booking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addBookingResult(id, bookingResult, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add a player
         * @param {string} id The booking id
         * @param {number} playerId The player id
         * @param {Player} player 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPlayer(id: string, playerId: number, player: Player, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Booking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPlayer(id, playerId, player, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get bookings availability
         * @param {AvailabilityRequest} availabilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async availability(availabilityRequest: AvailabilityRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.availability(availabilityRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Cancel Booking
         * @param {string} id booking id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelBooking(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelBooking(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a sale to pay players
         * @param {string} id The booking id
         * @param {Array<number>} playerIds The player id list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSale(id: string, playerIds: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreBooking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSale(id, playerIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a player
         * @param {string} id The booking id
         * @param {number} playerId The player id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePlayer(id: string, playerId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Booking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePlayer(id, playerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all customer\'s bookings
         * @param {number} start Zero-based page index
         * @param {number} size The page size
         * @param {boolean} [owner] True if bookings where owner is customer should be found. False if owner is customer or participant
         * @param {string} [include] Parameter to filter by date: all / next / old
         * @param {boolean} [includeCancelled] True to include cancelled bookings. False otherwise. Defaults to true
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findBookingByCustomer(start: number, size: number, owner?: boolean, include?: string, includeCancelled?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Booking>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findBookingByCustomer(start, size, owner, include, includeCancelled, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a booking by id
         * @param {string} id The booking id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findBookingById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Booking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findBookingById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a booking by crmId and tenantId
         * @param {string} tenantId The tenant id
         * @param {number} id The crm id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByCrmIdAndTenant(tenantId: string, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Booking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByCrmIdAndTenant(tenantId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get prices of players
         * @param {string} id The booking id
         * @param {Array<number>} playerIds The player id list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlayersPrices(id: string, playerIds: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlayersPricesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlayersPrices(id, playerIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get prices about the participants of a future booking
         * @param {PricesRequest} pricesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrices(pricesRequest: PricesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingPricesRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrices(pricesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Move a player
         * @param {string} id The booking id
         * @param {number} playerId The player id
         * @param {number} targetPlayerId The page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async movePlayer(id: string, playerId: number, targetPlayerId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Booking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.movePlayer(id, playerId, targetPlayerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a booking
         * @param {BookingRequest} bookingRequest 
         * @param {string} [xTenant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async prebooking(bookingRequest: BookingRequest, xTenant?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreBooking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.prebooking(bookingRequest, xTenant, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get availability and prices about a Tenant
         * @param {TenantAvailabilityRequest} tenantAvailabilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantAvailability(tenantAvailabilityRequest: TenantAvailabilityRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantAvailabilityDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantAvailability(tenantAvailabilityRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BookingApi - factory interface
 * @export
 */
export const BookingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BookingApiFp(configuration)
    return {
        /**
         * 
         * @summary Add a result to the booking
         * @param {string} id The booking id
         * @param {BookingResult} bookingResult 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBookingResult(id: string, bookingResult: BookingResult, options?: any): AxiosPromise<Booking> {
            return localVarFp.addBookingResult(id, bookingResult, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a player
         * @param {string} id The booking id
         * @param {number} playerId The player id
         * @param {Player} player 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPlayer(id: string, playerId: number, player: Player, options?: any): AxiosPromise<Booking> {
            return localVarFp.addPlayer(id, playerId, player, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get bookings availability
         * @param {AvailabilityRequest} availabilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        availability(availabilityRequest: AvailabilityRequest, options?: any): AxiosPromise<string> {
            return localVarFp.availability(availabilityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel Booking
         * @param {string} id booking id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelBooking(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.cancelBooking(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a sale to pay players
         * @param {string} id The booking id
         * @param {Array<number>} playerIds The player id list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSale(id: string, playerIds: Array<number>, options?: any): AxiosPromise<PreBooking> {
            return localVarFp.createSale(id, playerIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a player
         * @param {string} id The booking id
         * @param {number} playerId The player id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlayer(id: string, playerId: number, options?: any): AxiosPromise<Booking> {
            return localVarFp.deletePlayer(id, playerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all customer\'s bookings
         * @param {number} start Zero-based page index
         * @param {number} size The page size
         * @param {boolean} [owner] True if bookings where owner is customer should be found. False if owner is customer or participant
         * @param {string} [include] Parameter to filter by date: all / next / old
         * @param {boolean} [includeCancelled] True to include cancelled bookings. False otherwise. Defaults to true
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findBookingByCustomer(start: number, size: number, owner?: boolean, include?: string, includeCancelled?: boolean, options?: any): AxiosPromise<Array<Booking>> {
            return localVarFp.findBookingByCustomer(start, size, owner, include, includeCancelled, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a booking by id
         * @param {string} id The booking id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findBookingById(id: string, options?: any): AxiosPromise<Booking> {
            return localVarFp.findBookingById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a booking by crmId and tenantId
         * @param {string} tenantId The tenant id
         * @param {number} id The crm id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByCrmIdAndTenant(tenantId: string, id: number, options?: any): AxiosPromise<Booking> {
            return localVarFp.findByCrmIdAndTenant(tenantId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get prices of players
         * @param {string} id The booking id
         * @param {Array<number>} playerIds The player id list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayersPrices(id: string, playerIds: Array<number>, options?: any): AxiosPromise<PlayersPricesResponse> {
            return localVarFp.getPlayersPrices(id, playerIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get prices about the participants of a future booking
         * @param {PricesRequest} pricesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrices(pricesRequest: PricesRequest, options?: any): AxiosPromise<BookingPricesRequest> {
            return localVarFp.getPrices(pricesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Move a player
         * @param {string} id The booking id
         * @param {number} playerId The player id
         * @param {number} targetPlayerId The page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        movePlayer(id: string, playerId: number, targetPlayerId: number, options?: any): AxiosPromise<Booking> {
            return localVarFp.movePlayer(id, playerId, targetPlayerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a booking
         * @param {BookingRequest} bookingRequest 
         * @param {string} [xTenant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prebooking(bookingRequest: BookingRequest, xTenant?: string, options?: any): AxiosPromise<PreBooking> {
            return localVarFp.prebooking(bookingRequest, xTenant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get availability and prices about a Tenant
         * @param {TenantAvailabilityRequest} tenantAvailabilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantAvailability(tenantAvailabilityRequest: TenantAvailabilityRequest, options?: any): AxiosPromise<TenantAvailabilityDTO> {
            return localVarFp.tenantAvailability(tenantAvailabilityRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BookingApi - object-oriented interface
 * @export
 * @class BookingApi
 * @extends {BaseAPI}
 */
export class BookingApi extends BaseAPI {
    /**
     * 
     * @summary Add a result to the booking
     * @param {string} id The booking id
     * @param {BookingResult} bookingResult 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public addBookingResult(id: string, bookingResult: BookingResult, options?: AxiosRequestConfig) {
        return BookingApiFp(this.configuration).addBookingResult(id, bookingResult, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a player
     * @param {string} id The booking id
     * @param {number} playerId The player id
     * @param {Player} player 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public addPlayer(id: string, playerId: number, player: Player, options?: AxiosRequestConfig) {
        return BookingApiFp(this.configuration).addPlayer(id, playerId, player, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get bookings availability
     * @param {AvailabilityRequest} availabilityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public availability(availabilityRequest: AvailabilityRequest, options?: AxiosRequestConfig) {
        return BookingApiFp(this.configuration).availability(availabilityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel Booking
     * @param {string} id booking id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public cancelBooking(id: string, options?: AxiosRequestConfig) {
        return BookingApiFp(this.configuration).cancelBooking(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a sale to pay players
     * @param {string} id The booking id
     * @param {Array<number>} playerIds The player id list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public createSale(id: string, playerIds: Array<number>, options?: AxiosRequestConfig) {
        return BookingApiFp(this.configuration).createSale(id, playerIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a player
     * @param {string} id The booking id
     * @param {number} playerId The player id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public deletePlayer(id: string, playerId: number, options?: AxiosRequestConfig) {
        return BookingApiFp(this.configuration).deletePlayer(id, playerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all customer\'s bookings
     * @param {number} start Zero-based page index
     * @param {number} size The page size
     * @param {boolean} [owner] True if bookings where owner is customer should be found. False if owner is customer or participant
     * @param {string} [include] Parameter to filter by date: all / next / old
     * @param {boolean} [includeCancelled] True to include cancelled bookings. False otherwise. Defaults to true
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public findBookingByCustomer(start: number, size: number, owner?: boolean, include?: string, includeCancelled?: boolean, options?: AxiosRequestConfig) {
        return BookingApiFp(this.configuration).findBookingByCustomer(start, size, owner, include, includeCancelled, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a booking by id
     * @param {string} id The booking id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public findBookingById(id: string, options?: AxiosRequestConfig) {
        return BookingApiFp(this.configuration).findBookingById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a booking by crmId and tenantId
     * @param {string} tenantId The tenant id
     * @param {number} id The crm id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public findByCrmIdAndTenant(tenantId: string, id: number, options?: AxiosRequestConfig) {
        return BookingApiFp(this.configuration).findByCrmIdAndTenant(tenantId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get prices of players
     * @param {string} id The booking id
     * @param {Array<number>} playerIds The player id list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public getPlayersPrices(id: string, playerIds: Array<number>, options?: AxiosRequestConfig) {
        return BookingApiFp(this.configuration).getPlayersPrices(id, playerIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get prices about the participants of a future booking
     * @param {PricesRequest} pricesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public getPrices(pricesRequest: PricesRequest, options?: AxiosRequestConfig) {
        return BookingApiFp(this.configuration).getPrices(pricesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Move a player
     * @param {string} id The booking id
     * @param {number} playerId The player id
     * @param {number} targetPlayerId The page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public movePlayer(id: string, playerId: number, targetPlayerId: number, options?: AxiosRequestConfig) {
        return BookingApiFp(this.configuration).movePlayer(id, playerId, targetPlayerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a booking
     * @param {BookingRequest} bookingRequest 
     * @param {string} [xTenant] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public prebooking(bookingRequest: BookingRequest, xTenant?: string, options?: AxiosRequestConfig) {
        return BookingApiFp(this.configuration).prebooking(bookingRequest, xTenant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get availability and prices about a Tenant
     * @param {TenantAvailabilityRequest} tenantAvailabilityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public tenantAvailability(tenantAvailabilityRequest: TenantAvailabilityRequest, options?: AxiosRequestConfig) {
        return BookingApiFp(this.configuration).tenantAvailability(tenantAvailabilityRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
